
export default {
  props: {
    isTarget: {
      type: Boolean,
      default: true
    },
    tabData: {
      // tab数据，名称字段Name，code字段Code-----要保持和这个字段一致，不一致的在父元素处理好传进来
      type: Array,
      default: () => []
    },
    tabIndex: {
      // 当前页面的code值
      type: String,
      default: ''
    },
    searchShow: {
      // 是否显示搜索框
      type: Boolean,
      default: false
    },
    istran: {
      // 是否翻译，默认true翻译
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.positionId()
    window.onresize = () => {
      this.positionId()
    }
  },
  methods: {
    positionId() {
      if (!document.getElementById(this.tabIndex + '-a') && !document.getElementById(this.tabIndex + '-b')) return
      const ele = document.body.clientWidth > 799 ? document.getElementById(this.tabIndex + '-a') : document.getElementById(this.tabIndex + '-b')
      const position = ele.offsetLeft // 当前选中元素与左边框距离
      const screenWidth = ele.parentNode.parentNode.offsetWidth // 外围元素宽度
      const n = Math.ceil(screenWidth / 2) - position // 判断选中元素是否
      if (n < 0) ele.parentNode.scrollLeft = Math.abs(n)
    },
    search_f() {
      // 表单聚焦
      this.$emit('get_search')
    },
    emitfn(val) {
      this.$emit('emitfn', val)
    }
  }
}
